import { DataManActionCallbackOptions } from "../types/actions";
import { CallbackOrType } from "../types/common";

export async function getDataManCallbackOrTypeValue<T>(
  value: CallbackOrType<T>,
  options: DataManActionCallbackOptions
): Promise<T> {
  if (typeof value === "function") {
    if (value instanceof Function) {
      const result = (value as CallableFunction)(options);
      if (result instanceof Promise) {
        return await result;
      }
      return result;
    }
  }

  return value;
}
